import { tokenController } from "./tokenController"

const createHeader = () => {
    const token = tokenController();
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;

    return headers
}

const createHeaderForFiles = () => {
    const token = tokenController();
    const headers: Record<string, string> = { 'Content-Type': 'multipart/form-data' };
    if (token) headers.Authorization = `Bearer ${token}`;

    return headers
}

const createHeaderWithoutContentType = () => {
    const token = tokenController();
    const headers: Record<string, string> = {};
    if (token) headers.Authorization = `Bearer ${token}`;

    return headers
}



const ApiHelper = {
    createHeader,
    createHeaderForFiles,
    createHeaderWithoutContentType,
}

export default ApiHelper
